import FetchApi from './FetchApi';
import Configure from './Configure';
import { esCleanup } from './esCleanup';
import eventBus from '../event-bus-rx';

function _getHeaders() {
  return {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + Configure.getConfigs().access_token
  };
}

function _query(streamId, url, body, fetcher, errorCallback) {
  const results = eventBus.getTopic(streamId);

  const req = {
    method: 'post',
    headers: _getHeaders(),
    compress: true,
    body
  };

  const handleError = typeof errorCallback === 'function'
    ? errorCallback : (err) => console.log([url, req, err])

  fetcher(url, req).subscribe(
    (json) => {
      if (json.error) {
        eventBus.publish(
          streamId,
          { isLoading: false, isError: false, error: json.error }
        );
      }
      else {
        eventBus.publish(
          streamId,
          Object.assign({ isLoading: false, isError: false }, esCleanup(json))
        );
      }
    },
    (err) => handleError(err)
  );

  eventBus.publish(
    streamId,
    { isLoading: true }
  );

  return results;
}

const ErosApi = {
  query: (streamId, path, body, errorCallback) => {
    const url = `${Configure.getConfigs().erosUrl}/esquery`;
    const stringified = JSON.stringify({path, body: JSON.stringify(body)});
    return _query(streamId, url, stringified, FetchApi.doFetch, errorCallback);
  },
  queryCanned: (streamId, path, body, errorCallback) => {
    const url = `${Configure.getConfigs().erosUrl}/${path}`;
    const stringified = JSON.stringify(body);
    return _query(streamId, url, stringified, FetchApi.doFetch, errorCallback);
  },
  memoizeQuery: (streamId, path, body, errorCallback) => {
    const url = `${Configure.getConfigs().erosUrl}/esquery`;
    const stringified = JSON.stringify({path, body: JSON.stringify(body)});
    return _query(streamId, url, stringified, FetchApi.memoizeFetch, errorCallback);
  }
}

export default ErosApi;



/** WEBPACK FOOTER **
 ** ./lib/anuket-http/ErosApi.js
 **/